const getters = {
    tabTags: state => state.common.tabTags,
    permissions: state => state.user.permissions,
    user: state => state.user.userInfo,
    userId: state => state.user.userInfo.userId
}
export default getters
